import { render, staticRenderFns } from "./DisputeActivities.vue?vue&type=template&id=c7a5bb3a"
import script from "./DisputeActivities.vue?vue&type=script&lang=js"
export * from "./DisputeActivities.vue?vue&type=script&lang=js"
import style0 from "./DisputeActivities.vue?vue&type=style&index=0&id=c7a5bb3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports